import OPhoneDial from './index.vue';

OPhoneDial.install = app => {
  app.component(OPhoneDial.name, OPhoneDial);
};

export default OPhoneDial;
